<style lang="less" scoped>
.YearBar {position: relative;width: 1180px;height: 350px;text-align: left;}
.header {height: 12px;}
.type {font-size: 20px;letter-spacing: 2px;font-family: STHeiti;}
.el-button {font-size: 18px;color: black;}
.el-tabs {position: absolute;width:1180px;}
/deep/.el-tabs__item {font-size: 18px !important;}
.el-tab-pane {width: 1180px;}
ul {list-style: none;margin-left: -40px;margin-top: 5px;}
li {position: relative;cursor: pointer;margin-top: -15px;margin-bottom: 35px;margin-right: 10px;width: 580px;height: 133px;float: left;background-color: rgb(247, 247, 247);}
.pic{width: 272px;height: 134px;}
.newsTitle {font-size: 14px;height: 90px;margin-left: 15px;line-height: 22px; overflow: hidden;-webkit-line-clamp: 4;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;}
.time{position: absolute;bottom: 10px;right: 20px;font-size: 15px;}
.newsTitle:hover {color: #13569e;}
.YearBar span {color:blue;display:block;position: absolute;right: 0;height: 5px;margin-top: -35px;}
.icon-zuirehotchunse{font-size: 19px;color: #f30808;}
</style>

<!--何宽  2021.6.4
    该卡片组件使用场景：（往届回顾）tabs标签为时间轴，点击标签可以切换不同时间下的内容
    鼠标点击 更多 或者 新闻图片或标题，返回相应的对象给父组件-->
<template>
  <div class="YearBar">
    <div class="main">
      <el-tabs class="content" v-model="activeName" :stretch="true">
        <el-tab-pane v-for="(item, index) in Cardlist" :key="index" :label="item.title" :name="item.num">
          <ul class="newsList">
            <li v-for="(citem, cindex) in item.newsList" :key="cindex">
              <div class="text" style="height:100%;">
                <div class="icon-Title" style="display: flex;" @click="clickNewsYear(citem)">
                  <img :src="citem.thumb" class="icon" style="width: 228px;">
                  <div class="newsTitle"  style="margin-left:15px "> <i class="iconfont icon-zuirehotchunse"></i>{{ citem.introduce }} </div>
                </div>
                <div class="time"> {{ citem.edittime*1000 | formatDate()}} </div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: {Cardlist: {type: Array}},
  mixins: [filters],
  data()
  {
    return {
      activeName: '1'
    }
  },
  watch:
  {
    Cardlist(val)
    {
      this.activeName = val[0].num
    }
  },
  methods: {
    // 点击“更多”按钮，将该 button对象 传递给父组件
    getmore(button)
    {
      this.$emit('getmore', button)
    },
    // 点击新闻标题，将 news对象 传递给父组件
    clickNewsYear(citem)
    {
      this.$emit('clickNews', citem)
    }
  }
}
</script>

<!--  父组件数据格式
list: [
  {
    type: '往届回顾',
    button: {
      value: '更多',
      path: ''
    },
    content: [
      {
        id: '1',
        title: '2019',
        newsList: [
          {
            pic: '../../../static/img/news/LT1.png',
            icon: '../../../static/img/news/hotpoint.png',
            newsTitle: '《新闻联播》报道中国援建柬埔寨国家地质实验室落成暨移交仪式',
            time: '2019年10月16日',
            path: ''
          },
          {
            pic: '../../../static/img/news/LT2.png',
            icon: '../../../static/img/news/hotpoint.png',
            newsTitle: '2019（第十届）论坛活动保障及接待工作会议在南宁举行',
            time: '2019年11月11日',
            path: ''
          }
        ]
      },
      {
        id: '2',
        title: '2018',
        newsList: [
          {
            pic: '../../../static/img/news/LT1.png',
            icon: '../../../static/img/news/hotpoint.png',
            newsTitle: '《新闻联播》报道中国援建柬埔寨国家地质实验室落成暨移交仪式',
            time: '2019年10月16日',
            path: ''
          }
        ]
      },
    ]
  }
]
-->



// WEBPACK FOOTER //
// src/plugins/app/assembly/YearBar.vue